import React from 'react';
import classNames from 'classnames';
import { useChowaTheme } from './chowaThemeContext';

const ChowaCard = ({ children, className, style }) => {
  const { getCurrentTheme } = useChowaTheme();

  const currentTheme = getCurrentTheme();

  // カードの枠：テーマ色 or シリーズ選択時は選択色
  const borderStyle = {
    borderColor: currentTheme.primary,
    borderWidth: '2px',
    ...style // 外部から渡されるスタイルを適用
  };

  return (
    <div 
      className={classNames(
        'bg-white dark:bg-gray-800 rounded-lg border', // カードの中身：テーマの基本色
        className
      )}
      style={borderStyle}
    >
      {children}
    </div>
  );
};

export default ChowaCard; 